import { PageLoading } from 'module/ui/components/atoms/loading';
import { PageTemplateLite } from 'api/page-template/types';
import { useGetPageTemplateQuery } from 'queries/templates';
import { DocumentEditor } from 'components/organisms/document-editor';

export const TemplateViewer = ({
  template,
}: {
  template: PageTemplateLite;
}) => {
  const { data: templateData, isLoading } = useGetPageTemplateQuery(
    template.templateId,
  );

  return (
    <>
      {isLoading ? (
        <PageLoading size="small" />
      ) : (
        <div className="w-[670px] mx-auto pb-[80px]">
          <DocumentEditor
            value={templateData?.tiptapJson}
            className="editor-wrapper"
            readonly={true}
          />
        </div>
      )}
    </>
  );
};
